import { render } from "./Pagination.vue?vue&type=template&id=5a686d38"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=5a686d38&lang=scss&scope=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__